import { combineReducers } from "redux";
import { smsStatistics } from "./sms/sms.reducers";

export const product = combineReducers({
    smsStatistics
});